import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { Team } from "./pages/Team";
import { About } from "./pages/About";
import { Event } from "./pages/Event";
import { Contact } from "./pages/Contact";
import { EventDetail } from "./pages/EventDetail";
import { Navbar } from "./components/common/Navbar";
import { Footer } from "./components/common/Footer";
import PreLoader from "./components/pre-loader/pre-loader";
import ErrorPage from "./pages/ErrorPage";
import { HomePage } from "./pages/HomePage";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  

  return (
    <>
      
        <PreLoader />
           
      
      <div className=" w-screen bg-richblack-900 ">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage/>} />
          <Route path="/team" element={<Team />} />
          <Route path="/about" element={<About />} />
          <Route path="/event" element={<Event />} />
          <Route path="/contactUs" element={<Contact />} />
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

export default App;
